import { useCallback, useMemo } from 'react';
import { useServiceConnections } from '../../../smartLinks/catalog/useServiceConnections';
import { useArtistPortalConnect } from '../../../smartLinks/catalog/useArtistPortalConnect';
import { isSoundCloudCard } from '../../../smartLinks/catalog/soundCloud/soundCloudCardState';

/**
 * The SoundCloud connection for its card on Channels. SoundCloud is a channel too: Music24 uploads
 * songs to it. The card is the same as on Catalog → Sources (design soundcloud-connector a).
 */
export function useSoundCloudChannel({ accountId }: { accountId: number }) {
  const { connections, retry } = useServiceConnections({ accountId });
  const portal = useArtistPortalConnect({ accountId });
  const connection = useMemo(() => connections?.find(isSoundCloudCard), [connections]);

  const sync = useCallback(
    (integrationType: string) => {
      portal.sync(integrationType).catch(console.error);
    },
    [portal]
  );
  const disconnect = useCallback(
    (integrationType: string) => {
      portal.disconnect(integrationType).catch(console.error);
    },
    [portal]
  );

  return { connection, reload: retry, sync, disconnect, isBusy: portal.isBusy };
}
